module.exports = __webpack_public_path__ + "static/scale-model-of-carter-coile-county-doctor's-museum-in-athens-georgia-a8190328594cdbe0188f8dd65f9f3f21.png";